import axios from 'axios';
import config from './config';
import Cookies from "js-cookie";
import router from '@/router'
import { Message } from 'element-ui'
import {throttle} from '@/utils/utils'
// 使用vuex做全局loading时使用
// import store from '@/store'
export default function $axios (options) {
  return new Promise((resolve, reject) => {
    let tmpbaseURL = options.hostUrl ? options.hostUrl : config.zuul;
    let tmpTimeout = options.timeout ? options.timeout : config.timeout;
    let tmpHeaders = options.formType ? config.formHeaders : config.headers;
    const instance = axios.create({
      baseURL: tmpbaseURL,
      headers: tmpHeaders,
      timeout: tmpTimeout,
      withCredentials: config.withCredentials,
      method: options.method ? options.method : 'GET'
    })

    // request 拦截器
    instance.interceptors.request.use(
      config => {
        let token = sessionStorage.getItem('tkn')
        // 1. 请求开始的时候可以结合 vuex 开启全屏 loading 动画
        // console.log(store.state.loading)
        // console.log('准备发送请求...')
        // 2. 带上token
        if (token) {
          config.headers.token = token
        } else {
          // 重定向到登录页面
          router.push('/Login')
        }
        // 3. 根据请求方法，序列化传来的参数，根据后端需求是否序列化
        if (config.method === 'post') {

        }
        return config
      },
      error => {
        // 请求错误时
        console.log('request:', error)
        // 1. 判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          console.log('timeout请求超时')
        }
        // 2. 需要重定向到错误页面
        const errorInfo = error.response
        console.log(errorInfo)
        if (errorInfo) {
          error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status; // 404 403 500 ...
          router.push({
            path: `/error/${errorStatus}`
          })
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        // console.log(response);
        let data;
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.headers.filename) {
          data = {};
          data.data = response.data;
          data.filename = response.headers.filename;
        } else if (response.data == undefined) {
          data = JSON.parse(response.request.responseText)
        } else {
          data = response.data
        }

        // 根据返回的code值来做不同的处理
        switch (data.rc) {
          case 1:
            console.log(data.desc)
            break;
          case 0:
            store.commit('changeState')
          // console.log('登录成功')
          default:
        }
        // 若不是正确的返回code，且已经登录，就抛出错误
        // const err = new Error(data.desc)
        // err.data = data
        // err.response = response
        // throw err
        return data
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权，请登录'
              break
            case 403:
              sessionStorage.removeItem("user");
              sessionStorage.removeItem("userid");
              Cookies.remove('token');
              sessionStorage.removeItem('tkn')
              // 储存此次页面，方便下次登录跳转当前页面
              if(router.app.$route.path != '/Sys/PCindex') {
                localStorage.setItem('redirectToPageData',JSON.stringify({
                  path: router.app.$route.path,
                  name: router.app.$route.name,
                  query: router.app.$route.query
                }))
              }
              router.push('/Login');
              err.message = '拒绝访问';
              // 节流处理，响应提示
              throttle(() => {
                Message.info('登录已过期，请您重新登录')
              })
              // 返回reject则会被页面api catch响应error消息  
              return new Promise(() => {})
              // 取消请求
              break
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break
            case 408:
              err.message = '请求超时'
              break
            case 500:
              if (err.response.headers.xyjerror) {
                err.message = decodeURIComponent(err.response.headers.xyjerror);
              } else {
                err.message = err.response.data.message + "，错误号：" + err.response.data.status;
              }

              break
            case 501:
              err.message = '服务未实现'
              break
            case 502:
              err.message = '网关错误'
              break
            case 503:
              err.message = '服务不可用'
              break
            case 504:
              err.message = '网关超时'
              break
            case 505:
              err.message = 'HTTP版本不受支持'
              break
            default:
          }
        }
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )

    // 请求处理

    instance(options).then(res => {
      resolve(res);
      return false
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/http/axios.js